module.exports = __webpack_public_path__ + "img/logo.803d53c0.svg";